import { FocusMonitor } from '@angular/cdk/a11y';
import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, } from '@angular/core';
import { I18NService } from 'app/services/i18-n.service';
import { Subscription } from 'rxjs';
import { Contributor } from 'search/full-card/models/showcases';
import { EntityTypes } from '../../../../../../entity/models/entity';
import { Cover } from '../../../../../../models/cover';

@Component({
  selector: 'app-contributor',
  templateUrl: './contributor.component.html',
  styleUrls: ['./contributor.component.scss'],
})
export class ContributorComponent implements AfterViewInit, OnInit, OnDestroy, OnChanges {
  @ViewChild('item', { static: true }) public item: ElementRef;
  @Input() public contributor: Contributor;
  @Input() public focusedId: string;
  @Input() public isMouseEvent: boolean;
  @Input() public index: number;
  @Input() public identifier: string;
  public subscriptions = new Subscription();
  public coverConfig: Cover = {
    type: EntityTypes.AGENT,
    agentRoles: [''],
  };
  public contributorRoles: string;

  constructor(
    private readonly focusMonitor: FocusMonitor,
    private readonly i18nService: I18NService,
    ) {}

  public ngOnInit() {
    const roles = this.i18nService.mapCodesDescriptionsForRoles(this.contributor.relationshipTypes);
    this.coverConfig.agentRoles = roles.map((item) => item.code);
    this.contributorRoles = roles.filter((item) => item.description)
      .map((role) => (role.description.charAt(0).toUpperCase() + role.description.slice(1))).join(', ');
    this.coverConfig.coverUrl = this.contributor.coverUrl;
  }

  public ngAfterViewInit() {
    this.subscriptions.add(this.focusMonitor.monitor(this.item as any)
                               .subscribe((origin) => {
        if (origin === 'program' && !this.isMouseEvent || origin === 'keyboard') {
          this.item.nativeElement.classList.add('focused');
        } else {
          this.item.nativeElement.classList.remove('focused');
        }
      }));
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.focusedId && this.contributor.id === this.focusedId) {
      setTimeout(() => {
        this.item.nativeElement.focus();
      },0);
    }
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
